// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.caption-video-name {
    font-weight: bold;
}

.caption {
    padding: 10px;
    border-top: 1px solid black; /* Add a black bottom border */
    border-bottom: 1px solid black; /* Add a black bottom border */
}

.video-presentation {
    display: flex;
    flex-direction: row;
    height: 100%; /* Ensure the video presentation container fills the available height */
    max-width: 100%;
    margin: 0 auto;
    align-items: stretch; /* Align items to stretch to fill the container */
    border-left: 1px solid black; /* Add a right border */
}

.video-presentation>* {
    flex: 1 1;
}

.video-presentation .video-description-block {
    padding: 30px;
    background-color: white;
    display: flex;
    flex-direction: column;
    gap: 40px;
    border-right: 1px solid black; /* Add a right border */
    height: 100%; /* Ensure the description block fills the available height */
}

.video-description-block {
    text-align: justify;
    font-size: 16px;
    font-weight: 500;
    line-height: 30px;
}

.video-presentation .video-name {
    margin: 10px;
    font-size: 20px;
    align-self: center;
    text-transform: uppercase;
    font-weight: bold;
}

@media (max-width: 100%) {
    .video-presentation {
        flex-direction: column;
        height: auto;
    }

    video {
        width: 100%;
    }

    .video-presentation>* {
        flex-grow: 0;
        flex-shrink: 0;
        flex-basis: auto;
    }

    .video-player {
        margin-bottom: -6px;
    }
}

video::-webkit-media-controls-start-playback-button {
    display: none;
}
`, "",{"version":3,"sources":["webpack://./src/style/video-presentation.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,2BAA2B,EAAE,8BAA8B;IAC3D,8BAA8B,EAAE,8BAA8B;AAClE;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY,EAAE,uEAAuE;IACrF,eAAe;IACf,cAAc;IACd,oBAAoB,EAAE,iDAAiD;IACvE,4BAA4B,EAAE,uBAAuB;AACzD;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,6BAA6B,EAAE,uBAAuB;IACtD,YAAY,EAAE,4DAA4D;AAC9E;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI;QACI,sBAAsB;QACtB,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".caption-video-name {\n    font-weight: bold;\n}\n\n.caption {\n    padding: 10px;\n    border-top: 1px solid black; /* Add a black bottom border */\n    border-bottom: 1px solid black; /* Add a black bottom border */\n}\n\n.video-presentation {\n    display: flex;\n    flex-direction: row;\n    height: 100%; /* Ensure the video presentation container fills the available height */\n    max-width: 100%;\n    margin: 0 auto;\n    align-items: stretch; /* Align items to stretch to fill the container */\n    border-left: 1px solid black; /* Add a right border */\n}\n\n.video-presentation>* {\n    flex: 1;\n}\n\n.video-presentation .video-description-block {\n    padding: 30px;\n    background-color: white;\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n    border-right: 1px solid black; /* Add a right border */\n    height: 100%; /* Ensure the description block fills the available height */\n}\n\n.video-description-block {\n    text-align: justify;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 30px;\n}\n\n.video-presentation .video-name {\n    margin: 10px;\n    font-size: 20px;\n    align-self: center;\n    text-transform: uppercase;\n    font-weight: bold;\n}\n\n@media (max-width: 100%) {\n    .video-presentation {\n        flex-direction: column;\n        height: auto;\n    }\n\n    video {\n        width: 100%;\n    }\n\n    .video-presentation>* {\n        flex-grow: 0;\n        flex-shrink: 0;\n        flex-basis: auto;\n    }\n\n    .video-player {\n        margin-bottom: -6px;\n    }\n}\n\nvideo::-webkit-media-controls-start-playback-button {\n    display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
